module.exports = __webpack_public_path__ + "img/arrow-green.3a69dc7e.svg";